// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"operationUnits_page_wrapper__2BuIn","operationUnitContainer":"operationUnits_page_operationUnitContainer__1ApCb"};